import { render, staticRenderFns } from "./SUPCompanyDetailReport.vue?vue&type=template&id=061e1ab6&scoped=true"
import script from "./SUPCompanyDetailReport.vue?vue&type=script&lang=js"
export * from "./SUPCompanyDetailReport.vue?vue&type=script&lang=js"
import style0 from "./SUPCompanyDetailReport.vue?vue&type=style&index=0&id=061e1ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061e1ab6",
  null
  
)

export default component.exports